import React, { FunctionComponent, useEffect, useState, useCallback } from 'react'
import { IProps } from 'shared/ButtonsContainer/IProps'
import { IButton } from '../../../../../shared-ui/src/types/sections'

import { Container } from 'shared/ButtonsContainer/style'
import { useTranslation } from 'react-i18next'
import Spinner from 'shared/Spinner'
import { Button, Input, SaveButton, ToolTip, ToolTipWrapper, Error } from 'shared/ButtonsContainer/style'
import { isValidUrl } from 'utils/isValidUrl'

export const ButtonsContainer: FunctionComponent<IProps> = ({ data, updateSection, position, col }) => {
  const { t } = useTranslation()

  const [inputName, setInputName] = useState<string>('')
  const [inputLink, setInputLink] = useState<string>('')
  const [isToolTipVisible, setIsToolTipVisible] = useState<boolean>(false)
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [currentToolTipId, setCurrentToolTipId] = useState<string | null>(null)
  const [invalidUrl, setInvalidUrl] = useState<boolean>(false)

  useEffect(() => {
    if (data.content) {
      setInputName(data.content.name)
      setInputLink(data.content.link)
    }
  }, [data])

  const handleMouseEnter = (event: any) => {
    event.stopPropagation()
    setIsToolTipVisible(true)
    setIsEditing(true)
  }

  useEffect(() => {
    if (isToolTipVisible) {
      setCurrentToolTipId(`tooltipId-${col}`)
    }
  }, [isToolTipVisible, col])

  const handleClickOutside = useCallback(
    (event: any) => {
      if (currentToolTipId) {
        const tooltip = document.getElementById(currentToolTipId)
        if (tooltip && !tooltip.contains(event.target)) {
          setIsToolTipVisible(false)
        }
      }
    },
    [currentToolTipId, setIsToolTipVisible],
  )
  useEffect(() => {
    if (currentToolTipId) {
      document.addEventListener('click', handleClickOutside)
      return () => {
        document.removeEventListener('click', handleClickOutside)
      }
    }
  }, [currentToolTipId, handleClickOutside])

  const handleMouseLeave = () => {
    if (!isEditing) {
      setIsToolTipVisible(false)
    }
  }

  const handleSave = () => {
    const formattedLink = inputLink.startsWith('https://') ? inputLink : `https://${inputLink}`

    const checkUrl = isValidUrl(formattedLink);

    if (!checkUrl) {
      setInvalidUrl(true);
    }
    else {
      setInvalidUrl(false);

      const buttonDataObject: IButton = {
        name: inputName,
        link: formattedLink,
      }

      setIsToolTipVisible(false)
      setIsEditing(false)

      updateSection('button', { content: buttonDataObject }, position, col)
    }
  }

  if (!data) {
    return <Spinner isLoaded={true} />
  }

  return (
    <>
      <Container>
        <Button
          href={
            inputLink ? (/^https?:\/\//.test(inputLink) ? inputLink : `https://${inputLink}`) : 'https://example.com'
          }
          target="_blank"
          onMouseEnter={(event) => handleMouseEnter(event)}
          onMouseLeave={handleMouseLeave}
        >
          {inputName ? inputName : 'Default'}
        </Button>
        <ToolTip isToolTipVisible={isToolTipVisible} id={`tooltipId-${col}`}>
          <ToolTipWrapper>
            <Input
              value={inputName ? inputName : ''}
              onChange={(e) => setInputName(e.target.value)}
              placeholder="ex. Link"
            />
            <Input
              value={inputLink ? inputLink : ''}
              onChange={(e) => setInputLink(e.target.value)}
              placeholder="ex. https://example.com"
            />
            {invalidUrl && <Error>{t('This URL is invalid.')}</Error>}
            <SaveButton onClick={handleSave}>{t('Save')}</SaveButton>
          </ToolTipWrapper>
        </ToolTip>
      </Container>
    </>
  )
}
